import { render, staticRenderFns } from "./EmailPreview.vue?vue&type=template&id=20ba4add"
import script from "./EmailPreview.vue?vue&type=script&lang=js"
export * from "./EmailPreview.vue?vue&type=script&lang=js"
import style0 from "./EmailPreview.vue?vue&type=style&index=0&id=20ba4add&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports